/**
 *
 * @param array Array to index
 * @param key key to index the array
 * @param mapper function to map the values to index
 * @returns returns an object with the key as the index and the value as the value, if mapper is provided, the value will be the result of the mapper function
 */
export function index<T extends Record<string, any>, R = T>(
  array: T[],
  key: keyof T & string,
  mapper?: (item: T) => R
): Record<string, R> {
  return array.reduce(
    (obj, item) => {
      const k = item[key]
      if (k === undefined) {
        throw new Error(`Key ${String(key)} not found in array`)
      }
      obj[k] = mapper ? mapper(item) : (item as unknown as R)
      return obj
    },
    {} as Record<string, R>
  )
}

/**
 *
 * @param array Array to index
 * @param key key to index the array
 * @param mapper function to map the values to index
 * @returns returns an object with the key as the index and an array of values as the value, if mapper is provided, the values will be the result of the mapper function
 */
export function indexList<T extends Record<string, any>, R = T>(
  array: T[],
  key: keyof T & string,
  mapper?: (item: T) => R
): Record<string, R[]> {
  return array.reduce(
    (obj, item) => {
      const k = item[key]
      if (k === undefined) {
        throw new Error(`Key ${String(key)} not found in array`)
      }
      if (!obj[k]) obj[k] = []
      obj[k].push(mapper ? mapper(item) : (item as unknown as R))
      return obj
    },
    {} as Record<string, R[]>
  )
}
